// Small inline loading spinner. `center` wraps it in a padded flex box for
// empty-state / full-panel loading placeholders.
export function Spinner({
  size = 22,
  center = false,
  label,
}: {
  size?: number;
  center?: boolean;
  label?: string;
}) {
  const spin = (
    <span className="spinner" style={{ width: size, height: size }} aria-label={label ?? "Загрузка"}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4}>
        <path d="M12 3a9 9 0 1 0 9 9" strokeLinecap="round" />
      </svg>
    </span>
  );
  if (!center) return spin;
  return (
    <div className="spinner-box">
      {spin}
      {label && <span className="spinner-label">{label}</span>}
    </div>
  );
}
